var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.499 2.759a9.241 9.241 0 1 0 0 18.482 9.241 9.241 0 0 0 0-18.482"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#272A33",
  d: "M13.75 14.45h2.391l.376-2.43h-2.768v-1.328c0-1.01.33-1.904 1.274-1.904h1.517v-2.12c-.266-.036-.83-.115-1.895-.115-2.224 0-3.528 1.175-3.528 3.85v1.617H8.83v2.43h2.287v6.677a9 9 0 0 0 1.382.114c.425 0 .84-.039 1.25-.094z"
})));
export default SvgFacebook;